import * as React from 'react';
import { themr } from 'react-css-themr';

import { TABS } from 'react-toolbox/lib/identifiers';
import { tabsFactory } from 'react-toolbox/lib/tabs/Tabs';
import TabContent from 'react-toolbox/lib/tabs/TabContent';
import defaultTheme from 'react-toolbox/lib/tabs/theme.scss';
import { FontIcon } from 'react-toolbox/lib/font_icon';

import CardTabTheme from './TabWithCard.scss';
import { TabWithCard } from './TabWithCard';

const applyTheme = Component => themr(TABS, defaultTheme)(Component);
const applyCardTheme = Component => themr(TABS, CardTabTheme)(Component);

const DefaultTab = applyTheme(TabWithCard);
const DefaultTabContent = applyTheme(TabContent);

const CardTab = applyCardTheme(DefaultTab);
const CardTabContent = applyCardTheme(DefaultTabContent);

const DefaultCardTabs = tabsFactory(CardTab, CardTabContent, FontIcon);

class CustomCardTabs extends React.PureComponent {
    componentDidUpdate(prevProps) {
        const { index, children } = this.props;
        const { index: prevIndex, children: prevChildren } = prevProps;
        if (index !== prevIndex || children !== prevChildren) {
            this.cardRef && this.cardRef.updateArrows();
        }
    }
    getRef = cardRef => {
        const { _ref } = this.props;
        this.cardRef = cardRef;
        _ref && _ref(cardRef);
    };
    render() {
        return <DefaultCardTabs {...this.props} ref={this.getRef} />;
    }
}

const ThemedCardTabs = applyCardTheme(applyTheme(CustomCardTabs));
export { DefaultTab as CardTab, ThemedCardTabs as CardTabs, CardTabContent };
